<template>
    <div class='container'>

        <div class="tips">
            <span style=" cursor: pointer;" @click="back">
                <svg t="1695623560950" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="24436"
                    width="1.5em" height="1.5em" class="icon">
                    <path
                        d="M652.8 332.8H289.7408l102.3488-89.3952a51.2 51.2 0 0 0-67.3792-77.1072l-204.8 178.944a51.2 51.2 0 0 0-0.0512 77.056l204.8 179.456a51.0464 51.0464 0 0 0 72.2432-4.7616 51.2 51.2 0 0 0-4.7616-72.2432L289.9968 435.2h362.8032A166.6048 166.6048 0 0 1 819.2 601.6 166.6048 166.6048 0 0 1 652.8 768H486.4a51.2 51.2 0 1 0 0 102.4h166.4A269.1072 269.1072 0 0 0 921.6 601.6a269.1072 269.1072 0 0 0-268.8-268.8"
                        fill="#333333" p-id="24437"></path>
                </svg>
                文章專欄
            </span>
        </div>
        <div class="content">
            <div style="text-align:center">
                <img style="width: 100%;" :src="item.img" class="card-image">
            </div>
            <h4 class="title">{{ item.title }}</h4>
            <span v-if="item.time" style="display: flex;line-height: 30px;align-items: center"><svg style="margin-right: 10px;" t="1708660049688" class="icon" viewBox="0 0 1024 1024" version="1.1"
                            xmlns="http://www.w3.org/2000/svg" p-id="4363" width="20" height="20">
                            <path
                                d="M511.914 63.99c-247.012 0-447.925 200.912-447.925 447.924s200.913 447.925 447.925 447.925 447.925-200.913 447.925-447.925S758.926 63.989 511.914 63.989z m0 831.687c-211.577 0-383.763-172.186-383.763-383.763 0-211.577 172.014-383.763 383.763-383.763s383.763 172.014 383.763 383.763-172.186 383.763-383.763 383.763z"
                                fill="#bfbfbf" p-id="4364"></path>
                            <path
                                d="M672.06 511.914H512.085v-223.79c0-17.718-14.277-32.167-31.995-32.167-17.717 0-31.994 14.45-31.994 32.167V544.08c0 17.717 14.277 31.994 31.994 31.994H672.06c17.718 0 32.167-14.277 32.167-31.994-0.172-17.89-14.621-32.167-32.167-32.167z"
                                fill="#bfbfbf" p-id="4365"></path>
                        </svg>{{ item.time }}</span>
            <h6>{{ item.desc }}</h6>
            <div class="html" v-html="item.html"></div>
        </div>
        <div class="button">
            <button class="btns " :class="isfirst?'':'PreviousArticle'" @click="goToPreviousArticle"><svg t="1708486702333" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="1617" width="24" height="24"><path d="M767.7 480.9H207.1l217.7-217.7c12.3-12.3 12.3-32.4 0-44.7l-0.7-0.7c-12.3-12.3-32.4-12.3-44.7 0.1L107 490.3c-12.3 12.3-12.3 32.4 0 44.7l0.6 0.7c0.1 0 0.2 0.1 0.2 0.1l271.1 271.1c12.5 12.5 32.9 12.5 45.4 0s12.5-32.9 0-45.4L206.7 543.9h561c17.3 0 31.5-14.2 31.5-31.5s-14.2-31.5-31.5-31.5z" fill="#515151" p-id="1618"></path><path d="M864.1 512.6a31.8 31.7 0 1 0 63.6 0 31.8 31.7 0 1 0-63.6 0Z" fill="#515151" p-id="1619"></path></svg>上一篇</button>
            <button class="btns " :class="islast?'':'ToNextArticle'" @click="goToNextArticle">下一篇<svg t="1708486732793" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2599" width="24" height="24"><path d="M918.6 489.3L646.1 216.8c-12.3-12.3-32.5-12.3-44.8 0l-0.7 0.7c-12.3 12.3-12.3 32.4 0 44.7l218.7 218.7H257.6c-17.3 0-31.5 14.2-31.5 31.5s14.2 31.5 31.5 31.5h560.1L601.2 760.5c-12.5 12.5-12.5 32.9 0 45.4s32.9 12.5 45.4 0l271.1-271.1s0.1-0.1 0.2-0.1l0.7-0.7c12.3-12.3 12.3-32.4 0-44.7z" fill="#515151" p-id="2600"></path><path d="M97.6 512.6a31.8 31.7 0 1 0 63.6 0 31.8 31.7 0 1 0-63.6 0Z" fill="#515151" p-id="2601"></path></svg></button>
        </div>
    </div>
</div></template>
<script>
import { mapState } from 'vuex';
export default {
    components: {},
    data() {
        return {
            item: {

            },
            isfirst: true,
            islast: true,
        };
    },
    computed: {
        ...mapState('header', ['isarticle', 'article']),
    },
    watch: {
        '$route.params.id'(newid) {
            const currentIndex = this.findArticleIndex(newid);
            switch (currentIndex) {
                case 0:
                    this.isfirst = false;
                    break;
                case this.article.length - 1:
                    this.islast = false;
                    break;
                default:
                    this.isfirst = true;
                    this.islast = true;
                    break;
            }
        }
    },
    methods: {
        back() {
            this.$router.push({ path: '/article' });
        },
        findArticleIndex(articleId) {
            return this.article.findIndex(article => article.id === articleId);
        },
        goToPreviousArticle() {
            const currentIndex = this.findArticleIndex(this.$route.params.id);
            if (currentIndex > 0) {
                const prevArticleId = this.article[currentIndex - 1].id;
                this.$router.push({ path: '/article/' + prevArticleId });
                this.item = this.article[currentIndex - 1];
            } else {
                console.log("This is the first article.");
            }
        },
        goToNextArticle() {
            const currentIndex = this.findArticleIndex(this.$route.params.id);
            if (currentIndex < this.article.length - 1) {
                const nextArticleId = this.article[currentIndex + 1].id;
                this.$router.push({ path: '/article/' + nextArticleId });
                this.item = this.article[currentIndex + 1];
            } else {
                console.log("This is the last article.");
            }

        }

    },
    created() {
    },
    mounted() {
        //Q:获取当前页面路由的内容
        // console.log(this.$route.params.id);
        //Q:获取到对应的路由后this.$route.params.id我要从article里面提取到对应的内容
        this.item = this.article.find(article => article.id === this.$route.params.id);
        // if (this.findArticleIndex(this.$route.params.id) === 0) {
        //     this.isfirst = false;
        // }
        switch (this.findArticleIndex(this.$route.params.id)) {
            case 0:
                this.isfirst = false;
                break;
            case this.article.length - 1:
                this.islast = false;
                break;
            default:
                break;
        }
    },
}
</script>
<style lang='scss' scoped>
::v-deep {
    .html {
        p {
            // margin: 0;
        }

        img {
            display: block;
            width: 100%;
        }
    }
}
.button{
    position: absolute;
    bottom: 0;
    left: 0;
    text-align: right;
    width: 100%;
}
.PreviousArticle,.ToNextArticle{
    color: #ccc;
    cursor: not-allowed !important;
    svg{
        path{
            fill: #ccc;
        }
    }
}
.btns {
  padding: 0px;
  border: none;
  background: none; /* 可以更换为您喜欢的颜色 */
//   color: white;
  font-size: 16px;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s, transform 0.3s;
  text-decoration: none; /* 如果按钮是<a>标签 */
  display: inline-block; /* 对于<a>标签来说很重要 */
  margin: 0 5px;
  &:active{
    color: none;
  }
}
.tips {
    color: #6d5647;
    font-size: .8em;
    letter-spacing: .15em;
    padding: .5em 0;
    opacity: .8;

    .icon {
        font-size: 16px;
    }
}

.title {
    font-weight: bold;
    padding-top: 10px;
}

.content {
    padding: 0 10px;
    padding-bottom: 24px;
    max-width: 900px;
    margin: 0 auto;
}

.container {
    position: relative;
    // margin-top: 30px;
    padding: 0;
}


a {
    text-decoration: none;

}

@media (min-width: 1400px) {
    .container {
        max-width: 1140px;
    }
}

@media only screen and (max-width: 992px) {
    .container {
        padding: 15px;

    }
}
</style>